// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.target-menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
}

.target-menu-panel {
  pointer-events: auto;
  position: absolute;
  top: 50%;
  left: min(58%, 100% - 340px);
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  width: 300px;
  max-height: 84vh;
  padding: 10px;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: target-menu-in 0.14s ease-out;
}
.target-menu-panel * {
  box-sizing: border-box;
}
.target-menu-panel h3 {
  margin: 0;
}

@keyframes target-menu-in {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .target-menu-panel {
    animation: none;
  }
}
.target-menu-title {
  padding: 4px 8px 10px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 18px;
  letter-spacing: 0.02em;
  color: var(--gold-light);
}

.target-menu-scroll {
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}
.target-menu-scroll::-webkit-scrollbar {
  width: 6px;
}
.target-menu-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.target-menu-group {
  padding: 4px 0;
}
.target-menu-group + .target-menu-group {
  margin-top: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 8px;
}

.target-menu-group__title {
  padding: 2px 8px 4px;
  font-size: 12px;
  font-weight: 600;
  color: #8d8a82;
}

.target-menu-item {
  position: relative;
  display: block;
  width: 100%;
  padding: 8px 12px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.25;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.1s ease, color 0.1s ease;
}
.target-menu-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 22%;
  bottom: 22%;
  width: 3px;
  border-radius: 2px;
  background: var(--gold-main);
  opacity: 0;
  transition: opacity 0.1s ease;
}
.target-menu-item:hover, .target-menu-item:focus-visible {
  outline: none;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
}
.target-menu-item:hover::before, .target-menu-item:focus-visible::before {
  opacity: 1;
}
.target-menu-item--danger {
  color: #d9786d;
}
.target-menu-item--danger:hover, .target-menu-item--danger:focus-visible {
  color: #d9786d;
  background: rgba(217, 120, 109, 0.12);
}
.target-menu-item--danger:hover::before, .target-menu-item--danger:focus-visible::before {
  background: #d9786d;
}

.target-menu-footer {
  margin-top: 8px;
  padding: 8px 8px 2px;
  font-size: 12px;
  color: #8d8a82;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.target-menu-kbd {
  display: inline-block;
  padding: 1px 6px;
  margin-right: 2px;
  font-family: inherit;
  font-size: 11px;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/TargetMenu/TargetMenu.scss"],"names":[],"mappings":"AAgBA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,oBAAA;EACA,yDAAA;AAfF;;AAkBA;EACE,oBAAA;EACA,kBAAA;EACA,QAAA;EAEA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,cA1BK;EA2BL,kCA7BI;EA8BJ,2CAAA;EACA,kBAzBO;EA0BP,0CAAA;EACA,0BAAA;EACA,wCAAA;AAhBF;AAkBE;EAAI,sBAAA;AAfN;AAgBE;EAAK,SAAA;AAbP;;AAgBA;EACE;IAAO,UAAA;IAAY,4CAAA;EAXnB;EAYA;IAAO,UAAA;IAAY,yCAAA;EARnB;AACF;AAUA;EACE;IAAqB,eAAA;EAPrB;AACF;AASA;EACE,qBAAA;EACA,kDAAA;EACA,eAAA;EACA,sBAAA;EACA,wBAAA;AAPF;;AAUA;EACE,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,qDAAA;AAPF;AASE;EAAuB,UAAA;AANzB;AAOE;EAA6B,oCAAA;EAAsC,kBAAA;AAHrE;;AAMA;EACE,cAAA;AAHF;AAKE;EACE,eAAA;EACA,+CAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cA7EO;AAyET;;AAOA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA3FO;EA4FP,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,uDAAA;AAJF;AAME;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,6BAAA;AAJJ;AAOE;EAEE,aAAA;EACA,cAnHG;EAoHH,qCAAA;AANJ;AAQI;EAAY,UAAA;AALhB;AAQE;EAAY,cAtHL;AAiHT;AAME;EAEE,cAzHK;EA0HL,qCAAA;AALJ;AAOI;EAAY,mBA5HP;AAwHT;;AAQA;EACE,eAAA;EACA,oBAAA;EACA,eAAA;EACA,cArIO;EAsIP,+CAAA;AALF;;AAQA;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAjJK;EAkJL,oCAAA;EACA,2CAAA;EACA,kBAAA;AALF","sourcesContent":["// Contextual action menu (ALT on a player, a door or a chest).\n//\n// It sits to the right of the crosshair instead of covering it: the person or\n// the door you aimed at stays visible. Entries are grouped under short\n// headings so a long list (a guard or a Jarl has a dozen choices) can be\n// scanned. Same look as the escape menu: ink panel, one accent from the\n// global palette tokens, one corner radius.\n\n$ink: rgba(11, 15, 19, 0.94);\n$line: rgba(255, 255, 255, 0.14);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$radius: 6px;\n\n.target-menu-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  pointer-events: none;\n  font-family: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n}\n\n.target-menu-panel {\n  pointer-events: auto;\n  position: absolute;\n  top: 50%;\n  // To the right of the crosshair, but never pushed off a narrow screen.\n  left: min(58%, calc(100% - 340px));\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n  max-height: 84vh;\n  padding: 10px;\n  color: $text;\n  background: $ink;\n  border: 1px solid $line;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n  animation: target-menu-in 0.14s ease-out;\n\n  * { box-sizing: border-box; }\n  h3 { margin: 0; }\n}\n\n@keyframes target-menu-in {\n  from { opacity: 0; transform: translateY(-50%) translateX(-8px); }\n  to   { opacity: 1; transform: translateY(-50%) translateX(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .target-menu-panel { animation: none; }\n}\n\n.target-menu-title {\n  padding: 4px 8px 10px;\n  font-family: 'Marcellus', 'Cinzel', Georgia, serif;\n  font-size: 18px;\n  letter-spacing: 0.02em;\n  color: var(--gold-light);\n}\n\n.target-menu-scroll {\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n.target-menu-group {\n  padding: 4px 0;\n\n  & + & {\n    margin-top: 4px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    padding-top: 8px;\n  }\n}\n\n.target-menu-group__title {\n  padding: 2px 8px 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $text-3;\n}\n\n.target-menu-item {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.25;\n  text-align: left;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.1s ease, color 0.1s ease;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 22%;\n    bottom: 22%;\n    width: 3px;\n    border-radius: 2px;\n    background: var(--gold-main);\n    opacity: 0;\n    transition: opacity 0.1s ease;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    color: $text;\n    background: rgba(255, 255, 255, 0.07);\n\n    &::before { opacity: 1; }\n  }\n\n  &--danger { color: $danger; }\n  &--danger:hover,\n  &--danger:focus-visible {\n    color: $danger;\n    background: rgba(217, 120, 109, 0.12);\n\n    &::before { background: $danger; }\n  }\n}\n\n.target-menu-footer {\n  margin-top: 8px;\n  padding: 8px 8px 2px;\n  font-size: 12px;\n  color: $text-3;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.target-menu-kbd {\n  display: inline-block;\n  padding: 1px 6px;\n  margin-right: 2px;\n  font-family: inherit;\n  font-size: 11px;\n  color: $text;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
